/*!
 * bootstrap-fileinput v5.2.8
 * http://plugins.krajee.com/file-input
 *
 * Voir la police d'icone : https://tabler-icons.io/
 */
(function (factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'],factory);
    } else if (typeof module === 'object' && typeof module.exports === 'object') {
        factory(require('jquery'));
    } else {
        factory(window.jQuery);
    }
}(function ($) {
    "use strict";

    $.fn.fileinputThemes.uil = {
        fileActionSettings: {
            removeIcon: '<i class="uil uil-trash"></i>',
            uploadIcon: '<i class="uil uil-upload"></i>',
            uploadRetryIcon: '<i class="uil uil-redo"></i>',
            downloadIcon: '<i class="uil uil-download-alt"></i>',
            zoomIcon: '<i class="uil uil-search"></i>',
            dragIcon: '<i class="uil uil-expand-arrows"></i>',
            indicatorNew: '<i class="uil uil-plus text-warning"></i>',
            indicatorSuccess: '<i class="uil uil-check text-success"></i>',
            indicatorError: '<i class="uil uil-exclamation-triangle text-danger"></i>',
            indicatorLoading: '<i class="uil uil-hourglass text-muted"></i>',
            indicatorPaused: '<i class="uil uil-pause text-info"></i>'
        },
        layoutTemplates: {
            fileIcon: '<i class="uil uil-file kv-caption-icon"></i> '
        },
        previewZoomButtonIcons: {
            prev: '<i class="uil uil-angle-left"></i>',
            next: '<i class="uil-angle-right"></i>',
            toggleheader: '<i class="uil uil-arrows-v"></i>',
            fullscreen: '<i class="uil uil-expand-arrows-alt"></i>',
            borderless: '<i class="uil uil-arrows-h-alt"></i>',
            close: '<i class="uil uil-times"></i>'
        },
        previewFileIcon: '<i class="uil uil-file me-1"></i>',
        browseIcon: '<i class="uil uil-folder me-1"></i>',
        removeIcon: '<i class="uil uil-trash me-1"></i>',
        cancelIcon: '<i class="uil uil-times me-1"></i>',
        pauseIcon: '<i class="uil uil-pause"></i>',
        uploadIcon: '<i class="uil uil-upload me-1"></i>',
        msgValidationErrorIcon: '<i class="uil uil-exclamation-triangle"></i> '
    };
}));
